import { configureStore } from '@reduxjs/toolkit';
import drawingBoardReducer from '../features/drawingBoard/drawingBoardSlice';

export const store = configureStore({
  reducer: {
    drawingBoard: drawingBoardReducer,
  },
});
